module.exports = __webpack_public_path__ + "static/img/wrong10.022b7fe.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/wrong10.svg
// module id = d3Gz
// module chunks = 1